import React, { useState } from "react";
import "./CollapsibleSection.scss";
import { Button, Flex } from "@repo/ping-design";
import cx from "classnames";
import { useIsMobile } from "../../hooks/useIsMobile";

type CollapsibleSectionProps = {
  title: string | React.ReactNode;
  titleButton?: React.ReactNode;
  children: React.ReactNode;
  initialOpen?: boolean;
  hasDividingBorder?: boolean;
  containerStyles?: React.CSSProperties;
  isInternationalLocationError?: boolean;
};

const CollapsibleSection = ({
  title,
  children,
  titleButton,
  initialOpen = true,
  hasDividingBorder = false,
  containerStyles = {},
  isInternationalLocationError = false,
}: CollapsibleSectionProps) => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile ? false : !initialOpen);

  return (
    <div
      className={cx("CollapsibleSection", {
        "CollapsibleSection--Collapsed": collapsed,
      })}
    >
      <div className="CollapsibleSection__Title">
        <div className="CollapsibleSection__Title__Main">
          <div className="CollapsibleSection__Title__Main__Text">
            {title}
            {isInternationalLocationError && (
              <span className="BuildingsPanel__International_Location_Error">
                **
              </span>
            )}
          </div>
          <Flex gap="3">
            <div onClick={() => setCollapsed(false)}>{titleButton}</div>
            <Button
              iconName={collapsed ? "ChevronDown" : "ChevronUp"}
              size="sm"
              variant="outline"
              onClick={() => setCollapsed(!collapsed)}
            />
          </Flex>
        </div>
      </div>
      {!collapsed && (
        <hr
          style={{
            visibility: hasDividingBorder ? "visible" : "hidden",
          }}
        />
      )}

      <div
        className="CollapsibleSection__FilterContainer"
        style={{
          height: collapsed ? "0" : "auto",
          overflow: "hidden",
          ...containerStyles,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;
